module.exports = __webpack_public_path__ + "img/paypal.400e7bc9.svg";